import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonBack, CustomButton } from "../../../../core/components/CustomButton";
import { Container } from "../../../../core/components/Container";
import { TextComponent } from "../../../../core/components/TextComponent";
import { Toast } from "../../../../core/components/Toast";
import { submitLoginIssue } from "../../data/CommunityHelpDataSource";

export const LoginHelpScreen = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loginMethod, setLoginMethod] = useState("Gmail");
  const [whatHappened, setWhatHappened] = useState("");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleSubmit = async () => {
    if (!email.trim() || !whatHappened.trim()) {
      setMessage("Please enter your email and what happened.");
      return;
    }

    setSaving(true);
    try {
      await submitLoginIssue({
        email: email.trim(),
        loginMethod,
        whatHappened: whatHappened.trim(),
      });
      setEmail("");
      setWhatHappened("");
      setMessage("Thanks. Your login issue has been sent.");
    } catch {
      setMessage("Could not send this right now.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container className="w-full flex flex-col md:w-1/2 md:justify-center">
      <div className="w-full bg-white px-8 py-10 md:mx-auto md:max-w-xl md:rounded-lg">
        <ButtonBack onClick={() => navigate("/auth/login")} className="mb-6 text-primary">
          Login help
        </ButtonBack>
        <TextComponent variant="h5" className="text-graySecondary">
          Tell us what happened and the team will review it.
        </TextComponent>
        <div className="mt-6 grid gap-4">
          <label className="grid gap-1 text-sm font-semibold text-graySecondary">
            Email address
            <input
              value={email}
              type="email"
              onChange={(event) => setEmail(event.target.value)}
              className="rounded-md border border-grayLight px-3 py-3 text-black"
            />
          </label>
          <label className="grid gap-1 text-sm font-semibold text-graySecondary">
            Login method
            <select
              value={loginMethod}
              onChange={(event) => setLoginMethod(event.target.value)}
              className="rounded-md border border-grayLight px-3 py-3 text-black"
            >
              <option>Gmail</option>
              <option>Apple</option>
              <option>Email code</option>
              <option>Password</option>
            </select>
          </label>
          <label className="grid gap-1 text-sm font-semibold text-graySecondary">
            What happened?
            <textarea
              value={whatHappened}
              maxLength={1200}
              rows={6}
              onChange={(event) => setWhatHappened(event.target.value)}
              className="resize-y rounded-md border border-grayLight px-3 py-3 text-black"
            />
          </label>
          <CustomButton onClick={handleSubmit} loading={saving}>
            {saving ? "Sending..." : "Send login report"}
          </CustomButton>
        </div>
      </div>

      {message && (
        <Toast
          title="Login help"
          message={message}
          handleClose={() => setMessage(null)}
        />
      )}
    </Container>
  );
};
